import React, { useState } from "react";
import { TextAreaInput } from "@toddle-edu/ds-web";

const FeedbackInput = props => {
  const {
    feedback = "",
    projectId,
    debouncedUpdateSupervisorFeedback,
    criteriaId,
    columnId,
    t,
    studentId,
    disabled,
    isUserStudentOrParent,
  } = props;

  const [val, setVal] = useState(feedback);

  const onValChange = e => {
    const val = e.target.value;
    setVal(val);
    debouncedUpdateSupervisorFeedback({
      feedbackText: val,
      rowId: criteriaId,
      parentId: projectId,
      columnId,
      studentId,
    });
  };

  const placeholder =
    isUserStudentOrParent || (disabled && (!val || val == ""))
      ? t("common:no_feedback_added_yet")
      : t("common:type_here");

  return (
    <TextAreaInput
      dsVersion="2.0"
      value={val}
      onChange={onValChange}
      style={{ border: "none", backgroundColor: "transparent" }}
      placeholder={placeholder}
      disabled={disabled}
      minRows={6}
    />
  );
};

export default FeedbackInput;
